<template>
  <div>
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="fromParentBtn"
      :btnClass="'btn-primary'"
      :btnToLink="''"
      :routerSw="false"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{ alertMessage }}</bs-msg-alert>

    <h5>検索</h5>
    <div class="w100 mb-5">
      <div>
        <div>
          <p class="alert alert-warning">
            今日のデータであれば日付はそのまま空白で取得して下さい。
          </p>
        </div>
        <div class="row mb-1">
          <div class="col-3 mb-2">
            <p class="text-center py-1 fs-6">期間指定</p>
          </div>
          <div class="col-3 mb-2">
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                v-model="sprm.date"
                placeholder="yyyymmdd"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col text-center"></div>
          <div class="col text-center">
            <bs-button :btnClass="'btn-primary'" @to_click_event="get_log_data"
              >条件で取得</bs-button
            >
          </div>
          <div class="col text-end">
            <bs-button
              :btnClass="'btn-light btn-outline-secondary'"
              @to_click_event="clearSearch"
              >検索条件クリア</bs-button
            >
          </div>
        </div>
      </div>
    </div>

    <div class="w100">
      <h5>検索結果概要</h5>

      <div v-if="Array.isArray(parsedLogs) && parsedLogs.length > 0">
        <div class="w100 mb-5">
          <div>
            <div class="row mb-1">
              <div class="col-3 mb-2">
                <p class="text-center py-1 fs-6">抽出</p>
              </div>
              <div class="col-5 mb-2">
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    v-model="filter_words"
                    placeholder=""
                  />
                </div>
              </div>
              <div class="col-3 mb-2">
                <bs-button
                  :btnClass="'btn-warning'"
                  @to_click_event="applyFilter"
                  >抽出</bs-button
                >
              </div>
            </div>
          </div>
        </div>
        <!-- <div v-for="(log, index) in parsedLogs" :key="index" class="mb-3">
          <div class="text-muted fw-bold">{{ log.timestamp }}</div>
          <pre class="bg-light p-2 rounded">{{ log.body }}</pre>
        </div> -->
        <div
          v-for="(log, index) in parsedLogs"
          :key="index"
          class="mb-3 border rounded p-2 bg-light"
        >
          <div class="d-flex justify-content-between align-items-center">
            <div class="text-muted fw-bold">{{ log.timestamp }}</div>
            <button
              class="btn btn-sm btn-outline-secondary"
              @click="copyToClipboard(log.body)"
            >
              コピー
            </button>
          </div>
          <pre class="mt-2">{{ log.body }}</pre>
        </div>

        <!-- {{ payment_log }} -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
import BsButton from '../../atoms/BsButton.vue'
import config from '../../../const'

export default {
  name: 'GetPaymentLog',
  components: {
    BsPageTitle,
    BsMsgAlert,
    BsButton
  },
  data() {
    return {
      sprm: {
        date: ''
      },
      filter_words: '',
      payment_log: ''
    }
  },
  computed: {
    parsedLogs() {
      if (!this.payment_log || typeof this.payment_log !== 'string') {
        return [] // ログが未設定・無効な場合は空配列を返す
      }
      const rawLog = this.payment_log // ログ全体の文字列をここにバインドする（v-modelなど）

      const entries = rawLog
        .split(/\[(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d+\+\d{2}:\d{2})\]/)
        .slice(1) // 最初の空要素を除く

      const logs = []
      for (let i = 0; i < entries.length; i += 2) {
        const timestamp = entries[i]
        const logBody = entries[i + 1]?.trim()
        if (timestamp && logBody) {
          logs.push({
            timestamp,
            body: logBody
          })
        }
      }

      return logs.sort((a, b) => {
        const timeA = Date.parse(a.timestamp)
        const timeB = Date.parse(b.timestamp)
        if (isNaN(timeA) || isNaN(timeB)) return 0 // パースできない場合は並び替えしない
        return timeB - timeA
      })
    }
  },
  mounted() {},
  methods: {
    applyFilter() {
      if (!this.payment_log) {
        this.payment_log = ''
        return
      }

      const keywords = this.filter_words.trim().split(/\s+/) // 空白で分割
      const lines = this.payment_log.split('\n')

      const filtered = lines.filter(line =>
        keywords.every(word => line.includes(word))
      )

      this.payment_log = filtered.join('\n')
    },
    async get_log_data() {
      const params = {}
      params['date'] = this.sprm.date

      try {
        const response = await this.basicPosts_S(
          config.BASE_API_URL + '/manage/get_payment_log',
          params
        )
        this.payment_log =
          response.data && response.data.body ? response.data.body : ''
      } catch (err) {
        console.log(err)
        this.payment_log = ''
      } finally {
        this.$forceUpdate()
      }
    },
    copyToClipboard(text) {
      if (!navigator.clipboard) {
        // 古いブラウザ用 fallback
        const textarea = document.createElement('textarea')
        textarea.value = text
        document.body.appendChild(textarea)
        textarea.select()
        document.execCommand('copy')
        document.body.removeChild(textarea)
      } else {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            // 必要に応じてトースト表示など
            console.log('コピーしました')
          })
          .catch(err => {
            console.error('コピーに失敗しました', err)
          })
      }
    }
  }
}
</script>
